import LoadScript from './loadscript.vue';

export default {
  components: {
    LoadScript,
  },
};
